export const AuthAccount = 'au00-account/au01-verify-tokenezid';
export const Signout = 'au00-account/au02-signout';
export const SwitchSite = 'au00-account/au03-switch-site';
export const GetSessionUserSiteInfo = 'au00-account/au04-get-sessioninfo';